import { UserPreferencesData } from '@feature/user-preferences/models/user-preferences-data';
import * as userPreferenceActions from '../actions/user-preferences'

export interface State {
  effectiveValues: UserPreferencesData;
  error: string;
  loading: boolean;
}

export const INITIAL_STATE: State = {
  effectiveValues: null,
  error: null,
  loading: false
}

export function reducer(state: State = INITIAL_STATE, action: userPreferenceActions.Actions): State {
  switch (action.type) {
    case userPreferenceActions.LOAD_EFFECTIVE_VALUES:
    {
      return {
        ...state,
        loading: true
      };
    }
    case userPreferenceActions.LOAD_EFFECTIVE_VALUES_COMPLETE:
    {
      return {
        ...state,
        effectiveValues: action.payload,
        error: null,
        loading: false
      };
    }
    case userPreferenceActions.LOAD_EFFECTIVE_VALUES_ERROR:
    {
      var errorMessage = null;
      if (action.payload.hasOwnProperty('message')) {
        errorMessage = action.payload.message;
      }
      return {
        ...state,
        error: errorMessage,
        loading: false,
        effectiveValues: null
      };
    }
    default:
      {
        return state;
      }
  }

}
